import "./modal.css";
import React from "react";
import RModal from "react-modal";
import { stylex } from "./stylex";

if (process.env.NODE_ENV !== "test") {
  RModal.setAppElement("#root");
}

interface ModalProps extends RModal.Props {
  children?: React.ReactNode;
  transparent?: boolean;
}

export function Modal(props: ModalProps) {
  const { isOpen, onRequestClose, children, transparent = false } = props;

  return (
    <RModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={{
        content: styles("content", transparent && "transparent"),
        overlay: styles("overlay", transparent && "transparent"),
      }}
    >
      {children}
    </RModal>
  );
}

const styles = stylex.create({
  content: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    border: "none",
    backgroundColor: `rgb(255, 255, 255)`,
    overflow: "auto",
    borderRadius: 0,
    padding: 0,
  },
  overlay: {
    // On mobile, the checkout box modal (1055 z-index) is on top of the contact form modal
    // so we need to set a higher z-index for the contact form modal
    zIndex: 1056,
  },
  transparent: {
    backgroundColor: "transparent",
  },
});
